// src/utils/eventBus.js
import Vue from 'vue'

class EventBus {
  constructor () {
    this.bus = new Vue()
  }

  /**
   * 发送事件
   * @param {string} event 事件名称
   * @param {*} args 参数
   */
  emit (event, ...args) {
    this.bus.$emit(event, ...args)
  }

  /**
   * 监听事件
   * @param {string} event 事件名称
   * @param {Function} callback 回调函数
   */
  on (event, callback) {
    this.bus.$on(event, callback)
  }

  /**
   * 移除事件监听
   * @param {string} event 事件名称
   * @param {Function} callback 回调函数
   */
  off (event, callback) {
    this.bus.$off(event, callback)
  }

  /**
   * 一次性监听
   * @param {string} event 事件名称
   * @param {Function} callback 回调函数
   */
  once (event, callback) {
    this.bus.$once(event, callback)
  }
}

// 导出单例
export default new EventBus()
